"use strict";var e=require("react");const t=e.createContext(void 0);exports.NavigationContext=t,exports.NavigationContextProvider=r=>{let{children:o,value:a}=r;return e.createElement(t.Provider,{value:a},o)};
